import { useTranslation } from 'react-i18next';
import { Icon } from '@/common/components/Icons/Icon';
import { LabeledValueList } from '@/common/components/LabeledValueList/LabeledValueList';
import { OperationSummaryDetail } from '@/common/components/OperationDetail/components/OperationSummaryDetail/OperationSummaryDetail';
import { Stack } from '@/common/components/Stack/Stack';
import { IOperationVoucherExpense } from '@/common/integrations/menhir/employee/operations/operations.types';
import { formatDate, formatTime } from '@/common/utils/date';
import { MoneyUtils, TMoney } from '@coverflex-tech/hypernova-utils';

interface IMealDetailProps {
  operation: IOperationVoucherExpense;
}

export const MealDetailDrawer = ({ operation }: IMealDetailProps) => {
  const { t } = useTranslation();

  const externalCardValue = operation.descriptionParams?.find(
    (param) => param.key === 'external_card_value'
  )?.value as TMoney;

  return (
    <Stack grow>
      <Stack gap="xl">
        <OperationSummaryDetail
          icon={<Icon icon="utensils" color="accentSecondary10" />}
          operation={operation}
        />
        <LabeledValueList.Root title="">
          <LabeledValueList.Item
            label={t('general.labels.date_and_time')}
            value={t('general.labels.date_and_time.value', {
              date: formatDate(operation.executedAt),
              time: formatTime(operation.executedAt),
            })}
          />
          <LabeledValueList.Item
            label={t('dashboard.meal_voucher.expense.used_vouchers')}
            value={t('dashboard.meal_voucher.expense.used_voucher_amount', {
              count: operation.voucher.count,
              amount: MoneyUtils.moneyToString(operation.usedVoucherAmount),
            })}
          />
          {operation.usedEmployeeCreditAmount ? (
            <LabeledValueList.Item
              label={t('dashboard.meal_voucher.expense.used_credits')}
              value={MoneyUtils.moneyToString(
                operation.usedEmployeeCreditAmount
              )}
            />
          ) : null}
          {externalCardValue && (
            <LabeledValueList.Item
              label={t('dashboard.meal_voucher.expense.automatic_payment')}
              value={MoneyUtils.moneyToString(externalCardValue)}
            />
          )}
        </LabeledValueList.Root>
      </Stack>
    </Stack>
  );
};
